var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/index.js';
const Dashed = props => {
    const { icon, children, className } = props, rest = __rest(props, ["icon", "children", "className"]);
    return (React.createElement("button", Object.assign({ type: "button", className: clsx('relative block w-full border-2 border-line-subdued border-dashed rounded-lg p-12 text-center hover:border-line', 'focus:outline-none focus-visible:ring', className) }, rest),
        React.createElement(Icon, { className: "mx-auto h-12 w-12 text-content-subdued" }, icon),
        React.createElement("span", { className: "mt-2 block text-content" }, children)));
};
export const EmptyState = ({ title, description, icon, children, className, }) => {
    return (React.createElement("div", { className: clsx('text-center', className) },
        React.createElement(Icon, { className: "mx-auto h-12 w-12 text-content-subdued" }, icon),
        React.createElement("h3", { className: "mt-2 text-content" }, title),
        description && (React.createElement("p", { className: "mt-1 text-content-subdued" }, description)),
        children && React.createElement("div", { className: "mt-6" }, children)));
};
EmptyState.Dashed = Dashed;
//# sourceMappingURL=EmptyState.js.map